import { type Theme, useTheme } from '@/shared/lib';
import { Icon } from '@/shared/ui/icon';

import styles from './ThemeSwitch.module.scss';

const OPTIONS: ReadonlyArray<{ value: Theme; label: string }> = [
  { value: 'light', label: 'Светлая' },
  { value: 'dark', label: 'Тёмная' },
];

export function ThemeSwitch() {
  const [theme, setTheme] = useTheme();
  return (
    <div className={styles.switch} role="group" aria-label="Тема оформления">
      {OPTIONS.map((option) => (
        <button
          key={option.value}
          type="button"
          aria-label={option.label}
          title={option.label}
          aria-pressed={theme === option.value}
          onClick={() => setTheme(option.value)}
        >
          <Icon name={option.value === 'light' ? 'sun' : 'moon'} />
        </button>
      ))}
    </div>
  );
}
